import { Navigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";


interface ProtectedRouteProps {
  element: JSX.Element;
  allowedRoles?: string[];
}
export const PrivateRoute = ({ element, allowedRoles }: ProtectedRouteProps) => {
  const { isAuthenticated, role } = useAuth();
  // const user = UserDataStorage.get();
  // const token = user?.jwToken;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles  && !allowedRoles.includes(role || "")) {
    return <Navigate to="/unauthorized" replace />;
  }

  return element;
};
